// src/components/intranet/Cards/ComsAndPoliciesCard.js
import React from 'react';
import { CardActionArea, Typography, Box, useMediaQuery, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import PolicyIcon from '@mui/icons-material/Policy';

const ComsAndPoliciesCard = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <CardActionArea component={Link} to="/communications-and-policies" sx={{ height: '100%' }}>
      <Box
        sx={{
          backgroundColor: 'primary.main',
          display: 'flex',
          flexDirection: 'column',
          height: '90%',
          padding: 2,
          borderRadius: 2,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          margin: '0.5em 0',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: isSmallScreen ? 'column' : 'row',
            alignItems: isSmallScreen ? 'center' : 'flex-start',
            gap: 1,
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              backgroundColor: 'rgba(255, 255, 255, 0.15)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            }}
          >
            <PolicyIcon sx={{ fontSize: 40, color: '#ffffff' }} />
          </Box>
          <Box sx={{ textAlign: isSmallScreen ? 'center' : 'left' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', justifyContent: isSmallScreen ? 'center' : 'flex-start' }}>
              <Typography variant="h5" sx={{ color: '#ffffff' }}>
                Communications & Policies
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ mt: 1, color: '#ffffff' }}>
              Access company communications, announcements, and official policies all in one place.
            </Typography>
          </Box>
        </Box>
      </Box>
    </CardActionArea>
  );
};

export default ComsAndPoliciesCard;